import React, { useState } from "react";
import '../css/sg-platform.css';

const Popup = ({
  title,
  content,
  onClose,
  handleEmailSubmit,
  emailSentMessage,
}) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleEmailChange = (event) => {
    const inputEmail = event.target.value;
    setEmail(inputEmail);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(inputEmail)) {
      setEmailError("Por favor, insira um e-mail válido.");
    } else {
      setEmailError("");
    }
  };

  const handleSubmit = () => {
    if (!emailError && email) {
      handleEmailSubmit(email);
    } else if (!email) {
      setEmailError("O e-mail não pode estar vazio.");
    }
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>
        {title && <h2 className="popup-title">{title}</h2>}
        <div className="popup-body">
          {content}
          <div className="popup-email">
            <div className="input-email">
              <label className="popup-label" htmlFor="email">
                Email:
              </label>
              <input
                type="email"
                id="email"
                className="popup-input"
                placeholder="Coloque o seu email de registo"
                value={email}
                onChange={handleEmailChange}
              />
              <i className="fa-solid fa-envelope"></i>
            </div>
            <div>
              {emailError && <p className="error-message">{emailError}</p>}
            </div>
          </div>
          {emailSentMessage && (
            <p className="success-message">{emailSentMessage}</p>
          )}
          <button className="btn" onClick={handleSubmit}>
            Enviar<i className="fa-solid fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;